import { createTheme, responsiveFontSizes } from '@mui/material';

// Base colors
export const black = '#000000';
export const black02 = '#0a0a0a';

// Green palette
export const green01 = '#B3EC49';
// const green02 = '#A3DC39';
export const green03 = '#9FD63A';
export const green04 = '#72A11A';

// Grey palette
const greyP1 = '#F5F5F5';
export const greyP2 = '#B3B3B3';
export const greyP3 = '#747474';
export const greyP4 = '#313131';
export const greyP5 = '#232323';
// export const greyP6 = '#434343';

// Error/Warning colors
export const orangeError = '#FF8A00';

// Notification colors
export const notificationSuccess = {
  background: 'rgba(179, 236, 73, 0.85)', // green01 with 85% opacity
  accent: '#72A11A', // green04
  text: '#000000',
  subtitle: 'rgba(0, 0, 0, 0.7)',
};

export const notificationFailure = {
  background: 'rgba(203, 104, 104, 0.85)',
  accent: '#FF2323',
  text: '#FFFFFF',
  subtitle: 'rgba(255, 255, 255, 0.85)',
};

export const notificationWarning = {
  background: 'rgba(254, 184, 103, 0.85)',
  accent: '#FF7300',
  text: '#FFFFFF',
  subtitle: 'rgba(255, 255, 255, 0.85)',
};

// Progress bar colors
export const progressBarBackground = 'rgba(255, 255, 255, 0.6)';

// Toast configuration
export const TOAST_AUTO_CLOSE_DURATION = 5000; // milliseconds

export const theme = responsiveFontSizes(
  createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: green01,
        contrastText: black,
      },
      secondary: {
        main: greyP1,
        contrastText: black,
      },
      error: {
        main: orangeError,
      },
      background: {
        paper: 'transparent', // New from theme2
      },
    },
    typography: {
      fontFamily: 'AzbukaPro, sans-serif',
      h1: {
        fontFamily: 'AzbukaPro, sans-serif',
        fontWeight: 700,
      },
      h2: {
        fontFamily: 'AzbukaPro, sans-serif',
        fontWeight: 700,
      },
      h3: {
        fontFamily: 'AzbukaPro, sans-serif',
        fontWeight: 700,
      },
      h4: {
        fontFamily: 'AzbukaPro, sans-serif',
        fontWeight: 500,
      },
      h5: {
        fontFamily: 'AzbukaPro, sans-serif',
        fontWeight: 500,
      },
      h6: {
        fontFamily: 'AzbukaPro, sans-serif',
        fontWeight: 500,
      },
      button: {
        fontFamily: 'AzbukaPro, sans-serif',
        textTransform: 'none',
        fontWeight: 500,
      },
    },
    components: {
      MuiLink: {
        styleOverrides: {
          root: {
            color: green01,
            textDecoration: 'none',
            '&:hover': {
              textDecoration: 'underline',
            },
          },
        },
      },
      MuiCssBaseline: {
        styleOverrides: {
          a: {
            color: green01,
            textDecoration: 'none',
            '&:hover': {
              textDecoration: 'underline',
            },
          },
        },
      },
      // New components from theme2
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none',
            fontFamily: '"Azbuka Pro", sans-serif',
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: '#4a4a4a',
              },
              '&:hover fieldset': {
                borderColor: '#B3EC49',
              },
            },
          },
        },
      },
      MuiSelect: {
        styleOverrides: {
          root: {
            backgroundColor: '#1a1a1a',
          },
        },
      },
      MuiMenu: {
        styleOverrides: {
          paper: {
            backgroundColor: '#1a1a1a',
            backgroundImage: 'none',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          },
        },
      },
      MuiAutocomplete: {
        styleOverrides: {
          paper: {
            backgroundColor: '#1a1a1a',
            backgroundImage: 'none',
          },
        },
      },
    },
  }),
);
